<mbs-card-group>
  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.accessKey"
      [autocomplete]="'new-password'"
      [boldLabel]="true"
      [formControl]="accessKey"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.accessKey' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.accessKey' | i18next"
      [showRequiredMark]="false"></mbs-input>
  </mbs-form-group>

  <mbs-form-group>
    <mbs-input-password
      [attr.data-e2e]="e2eLocators.secretKey"
      [autocomplete]="'new-password'"
      [boldLabel]="true"
      [disabledEye]="secretKey.value === fakeSecretKey"
      [formControl]="secretKey"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.secretKey' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.secretKey' | i18next"
      [showRequiredMark]="false"></mbs-input-password>
  </mbs-form-group>
</mbs-card-group>
